import { Component, EventEmitter, Input, Output } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {

    @Input() urlGovCo: string = 'https://www.gov.co/home/';
    @Input() urlLogoGovCo: string = '/consultarenta/assets/images/logo_gov_co.png';
    @Input() urlLogoDian: string = '/consultarenta/assets/images/logo_DIAN_2025.png';
    @Input() govCoHeaderOnly: boolean = false;
    @Input() menuButton: boolean = false;
    @Input() title: string = '';

    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() onClickMenu: EventEmitter<any> = new EventEmitter<any>();

    links: any = {};

    constructor(){
        this.links = environment.enlaces;
    }

    openGovCo() {
        window.open(this.urlGovCo, '_blank');
    }

}
